import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6 mb-4">
            <h5 className="mb-3">
              <i className="bi bi-music-note-list me-2"></i>
              Işıltı Saz Evi
            </h5>
            <p className="mb-3">
              Geleneksel Türk müziği aletlerinin üretimi ve satışında 
              uzman olan firmamız, kaliteli işçilik ve doğal malzemeler 
              kullanarak müzik severlere hizmet vermektedir.
            </p>
            <div className="d-flex gap-3 flex-wrap">
              <a 
                href="https://www.facebook.com/is.lt.saz.evi/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link facebook"
                title="Facebook"
              >
                <i className="bi bi-facebook"></i>
              </a>
              <a 
                href="https://instagram.com/isiltisazevi" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link instagram"
                title="Instagram"
              >
                <i className="bi bi-instagram"></i>
              </a>

              <a 
                href="https://wa.me/905356091300" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link whatsapp"
                title="WhatsApp"
              >
                <i className="bi bi-whatsapp"></i>
              </a>
            </div>
          </div>
          
          <div className="col-lg-4 col-md-6 mb-4">
            <h6 className="mb-3">Hızlı Linkler</h6>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/" className="text-white text-decoration-none">
                  Ana Sayfa
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/products" className="text-white text-decoration-none">
                  Ürünler
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/categories" className="text-white text-decoration-none">
                  Kategoriler
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" className="text-white text-decoration-none">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>
          
          <div className="col-lg-4 col-md-6 mb-4">
            <h6 className="mb-3">İletişim</h6>
            <ul className="list-unstyled">
              <li className="mb-2">
                <i className="bi bi-geo-alt me-2"></i>
                <small>Çevik Bir Meydanı /127 Sok. No:18/A, İzmir, Turkey 35380</small>
              </li>
              <li className="mb-2">
                <i className="bi bi-telephone me-2"></i>
                <a href="tel:+905356091300" className="text-white text-decoration-none">
                  +90 535 609 13 00
                </a>
              </li>
              <li className="mb-2">
                <i className="bi bi-envelope me-2"></i>
                <a href="mailto:info@isiltisazevi.com" className="text-white text-decoration-none">
                  info@isiltisazevi.com
                </a>
              </li>
              <li className="mb-2">
                <i className="bi bi-clock me-2"></i>
                <small>Hafta İçi: 09:00-18:00<br/>Cumartesi: 09:00-18:00<br/>Pazar: İletişime geçebilirsiniz</small>
              </li>
            </ul>
          </div>
        </div>
        
        <hr className="my-4" />
        
        <div className="row align-items-center">
          <div className="col-md-6">
            <p className="mb-0">
              &copy; {currentYear} Işıltı Saz Evi. Tüm hakları saklıdır.
            </p>
          </div>
          <div className="col-md-6 text-md-end">
            <Link to="/contact" className="text-white text-decoration-none me-3">
              İletişim
            </Link>
            <Link to="/products" className="text-white text-decoration-none">
              Ürünler
            </Link>
          </div>
        </div>
        
        <hr className="my-3 opacity-50" />
        
        <div className="row">
          <div className="col-12 text-center">
            <p className="mb-0 small opacity-75">
              <i className="bi bi-code-slash me-2"></i>
              Created by <span className="fw-bold text-white">Eraycan Uyanık</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
